import { render, staticRenderFns } from "./PostCardMobile.vue?vue&type=template&id=d6e4a8a8&"
import script from "./PostCardMobile.vue?vue&type=script&lang=js&"
export * from "./PostCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports